import { LUDUM_SPORTS } from '@/constants';
const { ERGO, BIKE } = LUDUM_SPORTS;

export const VIEW_TYPES = {
    LIST: 'list',
    GRAPH: 'graph'
};

export const widgetImprovements = {
    namespaced: true,

    state: {
        [ERGO]: {
            view: VIEW_TYPES.LIST,
            squad: null
        },
        [BIKE]: {
            view: VIEW_TYPES.LIST,
            squad: null
        }
    },

    getters: {
        viewErgo(state) {
            return state[ERGO].view;
        },

        squadErgo(state) {
            return state[ERGO].squad;
        },

        viewBike(state) {
            return state[BIKE].view;
        },

        squadBike(state) {
            return state[BIKE].squad;
        }
    },

    mutations: {
        updateView(state, { sportId, view }) {
            state[sportId].view = view;
        },

        updateSquad(state, { sportId, squad }) {
            state[sportId].squad = squad;
        }
    }
};

export default widgetImprovements;
